import { apiFetch, readJson, readErrorMessage } from './client';
import type { StorageAccessMode, StorageMountKind, UpsertAccessRequest } from './storageMountsAdmin';

export interface ClientSpaceRoles {
  opsRoles: string[];
  clientRoles: string[];
}

export interface ProvisionClientSpaceRequest {
  tenantId: string;
  displayName: string;
  kind: StorageMountKind;
  settingsJson: string;
  fileReviewStorageKey?: string | null;
  opsDisplayName?: string | null;
  opsAccess: UpsertAccessRequest[];
  clientAccess: UpsertAccessRequest[];
}

export interface ProvisionClientSpaceResult {
  clientMountId: string;
  opsMountId: string;
  fileReviewStorageKey: string;
}

export type { StorageAccessMode };

export async function listClientSpaceRoles(): Promise<ClientSpaceRoles> {
  const res = await apiFetch('/api/admin/client-space-provisioning/roles');
  if (!res.ok) throw new Error(await readErrorMessage(res));
  return readJson<ClientSpaceRoles>(res);
}

export async function provisionClientSpace(
  req: ProvisionClientSpaceRequest
): Promise<ProvisionClientSpaceResult> {
  const res = await apiFetch('/api/admin/client-space-provisioning', {
    method: 'POST',
    body: JSON.stringify(req)
  });
  if (!res.ok) throw new Error(await readErrorMessage(res));
  return readJson<ProvisionClientSpaceResult>(res);
}
